import { UserService } from '../../users/shared/user.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'username',
  standalone: false
})
export class UsernamePipe implements PipeTransform {
  constructor(private _userService: UserService) {}
  transform(value: number): Promise<string> {
    if (value) {
      return this._userService.get(value).then((data) => {
        if (data?.UserName) {
          return Promise.resolve(data.UserName);
        } else {
          return Promise.resolve('');
        }
      });
    } else {
      return Promise.resolve('');
    }
  }
}
